
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"ql-fill",attrs:{"d":"M10 4v10a1 1 0 01-2 0v-4H3v4a1 1 0 01-2 0V4a1 1 0 012 0v4h5V4a1 1 0 012 0zm6.068 9.209H14.99v-5.61a.54.54 0 00-.605-.606h-.628a1.011 1.011 0 00-.748.297l-1.364 1.276a.543.543 0 00-.022.859l.286.307a.539.539 0 00.847.034l.1-.088a1.214 1.214 0 00.241-.353h.023s-.012.309-.012.606v3.278h-1.067a.54.54 0 00-.605.605v.44a.54.54 0 00.605.605h4.027a.54.54 0 00.605-.605v-.44a.54.54 0 00-.605-.605z"}})])
          )
        }
      }
    